import React from 'react'

import MediaPageService from './Service'

import { useServiceState, useNotification } from 'helpers'

import { IMediaPageProviderProps, Link } from './Interfaces'
import SessionManagerService from 'smart-components/session-manager/Service'
import IMedia from 'types/sign-in/IMedia'

const Provider: React.FC<IMediaPageProviderProps> = ({ children }) => {
  const state = useServiceState(MediaPageService)
  const sessionState = useServiceState(SessionManagerService, false)
  const { emitSuccess, emitError } = useNotification()

  const uploadFile = async (file: File) => {
    const [response, error] = await MediaPageService.doUploadFile(file)
    if (error) {
      emitError(error)
    } else {
      emitSuccess('Media changed with success!')
      SessionManagerService.setCurrentUser(response.data)
    }
  }

  const deleteFile = async () => {
    await uploadFile(null)
    MediaPageService.clearFile()
  }

  const saveLink = async (link = null as Link) => {
    const result = await MediaPageService.doSave(link)
    if (result) {
      const [response, error] = result
      if (error) {
        emitError(error)
      } else {
        emitSuccess('Media changed with success!')
        SessionManagerService.setCurrentUser(response.data)
      }
    }
  }

  const deleteLink = async (index: number) => {
    const [response, error] = await MediaPageService.doDeleteLink(index)
    if (error) {
      emitError(error)
    } else {
      emitSuccess('Media link deleted with success!')
      SessionManagerService.setCurrentUser(response.data)
    }
  }

  return (
    <React.Fragment>
      {children({
        state,
        onDeleteFile: () => deleteFile(),
        doUpload: () => uploadFile(state.file),
        clearFile: () => MediaPageService.clearFile(),
        medias: (sessionState.currentUser || {}).medias || ([] as IMedia[]),
        setFile: (file: File) => MediaPageService.setFile(file),
        onChangeLinkUrl: (value: string) => MediaPageService.onChangeLinkUrl(value),
        onChangeLinkName: (value: string) => MediaPageService.onChangeLinkName(value),
        doSave: () => saveLink({ name: state.linkName, url: state.linkUrl }),
        onDeleteLink: deleteLink
      })}
    </React.Fragment>
  )
}

export default Provider
